<template>
  <v-row 
    :class="evaluateClasses(
      classes,
      'dr-grid-layout-row',
      isInEditorMode ? 'dr-grid-layout-row-editor-mode' : '',
      isSelectedRow() ? 'dr-grid-layout-row-selected' : ''
    )"
  >

    <!--  Отрисовка кнопки удаления для строк в панели свойств -->
    <portal to="action-buttons" v-if="isSelectedRow()">
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn :disabled='readonly' v-on="on" text color="error" @click="onDeleteRow">
            <font-awesome-icon :icon="['fal', 'trash-alt']" size="lg"/>
          </v-btn>
        </template>
        <span>{{ $t("vuetifyWidgets.common.remove") }}</span>
      </v-tooltip>

      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn :disabled='readonly' v-on="on" text color="success" @click="onAddColumn">
            <font-awesome-icon :icon="['fal', 'plus']" size="lg"/>
            <font-awesome-icon :icon="['fal', 'grip-vertical']" size="lg"/>
          </v-btn>
        </template>
        <span>{{ $t("vuetifyWidgets.dr-grid-layout.addColumn") }}</span>
      </v-tooltip>

      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn :disabled='readonly' v-on="on" text color="success" @click="onAddRow">
            <font-awesome-icon :icon="['fal', 'plus']" size="lg"/>
            <font-awesome-icon :icon="['fal', 'grip-horizontal']" size="lg"/>
          </v-btn>
        </template>
        <span>{{ $t("vuetifyWidgets.dr-grid-layout.addRow") }} </span>
      </v-tooltip>
    </portal>

    <!-- шапка строки -->
    <div v-if="isInEditorMode" class="dr-grid-layout-row-header"
      @click.stop="selectComponent(model)"
      @contextmenu="onShowContextMenu" >
      <div class="dr-grid-layout-row-header-corner"></div>
    </div>
    <!-- колонки -->
    <draggable
      v-if="isInEditorMode"
      :class="['dr-display-row', evaluateExpression(model.Class)]"
      :group="{ name:'row' }"
      :swapThreshold="0.95"
      :emptyInsertThreshold="20"
      @add="onWidgetDraggableAdd"
      :disabled="readonly"
      @update="onModelChanged"
      @change="onDraggableChanged"
      @start="onStartDraggable"
      :list="model.Columns">

      <dr-grid-layout-column
          v-for="column in model.Columns"
          :key="column.$ID"
          :parentsWidgets="currentListOfParentsWidgets"
          :readonly="readonly"
          :model="column"
          @modelChanged="onModelChanged"
          @deleteColumn="onDeleteColumn"
          @addColumn="onAddColumn">
      </dr-grid-layout-column>
    </draggable>

    <template v-else-if="isVisible">
      <!-- Виджеты -->
      <dr-grid-layout-column
        v-for="(column) in model.Columns"
        :key="column.$ID"
        :dataSource="dataSource" @callDataSourceAction="$emit('callDataSourceAction', $event)"
        :parentDataWidget="parentDataWidget"

        :model="column">
      </dr-grid-layout-column>
    </template>
    
    <!-- Контекстное меню -->
    <widgets-context-menu 
      v-if="isInEditorMode"
      v-model="showContextMenu" 
      :x="x" 
      :y="y"
      :snippetCreatable="false"
      :widgetModel="model"
      @deleteComponent="onDeleteRow"
      @pasteCopiedWidget="onPasteCopiedWidget"
    />
  </v-row>
</template>

<script>
import inputMixin from '../../mixins/input-mixin'
import widgetsWrapperMixin from '../../mixins/widgets-wrapper-mixin'
import mixin from '../../mixins//base-mixin'
import contextMenuMixin from '../../mixins/contextmenu-mixin'
import jsonPatchMixin from '../../mixins/jsonPatchMixin'

export default {
  name: 'dr-grid-layout-row',
  mixins: [mixin, inputMixin, contextMenuMixin, widgetsWrapperMixin, jsonPatchMixin],
  props: ['model'],
  data() {
    return {}
  },
  methods: {
    onModelChanged() {
      this.$emit('modelChanged', this.model)
    },
    // Удаление колонки из строки
    onDeleteColumn(val) {
      this.model.Columns = this.model.Columns.filter(column => column != val)
      if (!this.model.Columns.length) {
        this.onDeleteRow()
        return
      }
      this.$emit('modelChanged')
      this.widgetsHelper.setSelectedWidget(undefined)
    },
    // Выбор строки по клику на шапку
    isSelectedRow() {
      return this.$store.state[this.stateName].selectedWidget  == this.model
    },
    // Удаление строки
    onDeleteRow() {
      this.$emit('deleteRow', this.model)
    },
    // Добавление колонки в строку
    onAddColumn() {
      let newColumn = {
        $ID: Math.random() + '',
        $Type: 'dr-grid-layout-column',
        Weight: 1,
        Widgets: []
      }
      this.model.Columns.push(newColumn)
      this.onModelChanged()
    },
    // Добавление строки
    onAddRow() {
      this.$emit('addRow')
    }
  }
}
</script>
